export function PortalButton({
  children,
  onClick,
  style = {},
  variant = "primary", // future-proof
}) {
  return (
    <button
      onClick={onClick}
      style={{
        ...baseButtonStyle,
        ...getButtonVariant(variant),
        ...style,
      }}
    >
      {children}
    </button>
  );
}

const baseButtonStyle = {
  padding: "0.6rem 1.2rem",
  borderRadius: "6px",
  border: "none",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: "0.95rem",
  transition: "all 0.2s ease",
};

function getButtonVariant(variant) {
  switch (variant) {
    case "secondary":
      return {
        background: "#ffffff",
        color: "#114c96",
        border: "1px solid #114c96",
      };

    default:
      return {
        background: "#114c96",
        color: "#ffffff",
      };
  }
}